import { render } from "./AvatarInitials.vue?vue&type=template&id=ec5827f0"
import script from "./AvatarInitials.vue?vue&type=script&lang=js"
export * from "./AvatarInitials.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__